import { httpRequest } from "@services/http";

export class CommandDeleteRole {
  async run(roleId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/${roleId}`;
    try {
      await httpRequest(url, { method: "DELETE" });
    } catch (error) {
      console.error("Error deleting role:", error);
      throw error;
    }
  }
}
